import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import { SOURCE_URL } from '../../../config';

interface SupportContactUsLayoutProps {
    element: any
}

const SupportContactUsLayout: React.FC<SupportContactUsLayoutProps> = (element) => {
    
    return (
      <>
        <div className="container-fluid spacer-top contact-us-layout">
            <h3 className="text-center mb-5 font-medium">{element?.element?.SectionTitle}</h3>
            <div className="row justify-content-center lg_font_size text-center barlow-font">
                <div className="col-md-2 col-sm-3 mb-sm-0 mb-3">
                    <a href={element?.element?.Link}>
                        <img src={SOURCE_URL + element?.element?.Icon?.data?.attributes?.url} alt="" className="d-block mx-auto mb-3 img-fluid" />
                    </a>
                    <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{element?.element?.Label}</ReactMarkdown>
                </div>
            </div>
            {element?.element?.AdditionalContactLink ?
            <div className="text-center">
                <span className="d-block py-5 light-gray">or</span>
                <a href={element?.element?.AdditionalContactLink} className="color-4 arrowed-link lg_font_size">
                    {element?.element?.AdditionalContactLinkText}
                    <i className="icon-angle-right"></i>
                </a>
            </div>
            :<></>}
        </div>
      </>
    );
};

export default SupportContactUsLayout;